import React from 'react'
import cls from 'classnames'

import classes from './Sticker.module.scss'

export default function Sticker(props) {
	return (
		<div
			className={cls(
				classes.Sticker,
				props.className
			)}
		>
			{props.children}
		</div>
	)
}